import AuthLayout from "layouts/AuthLayout";

const statisticStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
};


const SiteClosed = () => {
  return <AuthLayout>
    <div style={statisticStyle}>
    <h1>The MicroCred Seeker platform has now closed.</h1>
    <div >
      <p >Thank you for your contribution to this pilot program.</p>
      <p>If you have questions, please email <a href="mailto:MicroCredSeeker@education.gov.au">MicroCredSeeker@education.gov.au</a>.</p>
       </div>
    </div>
    </AuthLayout>
  
};

export default SiteClosed;
